const moduleOrder = [
  'summary',
  'dashboard',
  'monitoring',
  'master-data',
  'input-data',
  'user-role',
  'config-input'
]
export default moduleOrder



// WEBPACK FOOTER //
// ./src/modules/_order.js